
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/mini-leagues/join",
      function () {
        return require("private-next-pages/[slug]/mini-leagues/join.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/mini-leagues/join"])
      });
    }
  